import { Col, Row } from "react-bootstrap";

export default function CardVaca({ animal }) {
    return (
        <>
            <Row className="mb-3">
                <Col md={4}><strong>Identificador:</strong> {animal.identifier}</Col>
                <Col md={4}><strong>Raza:</strong> {animal.breed}</Col>
                <Col md={4}><strong>Fecha de nacimiento:</strong> {animal.birthDate?.slice(0,10)}</Col>
            </Row>
            <Row className="mb-3">
                <Col md={4}><strong>Último parto:</strong> {animal.lastCalvingDate?.slice(0,10) || '—'}</Col>
                <Col md={4}><strong>Situación reproductiva:</strong> {animal.reproductiveStatus || '—'}</Col>
                <Col md={4}><strong>Situación productiva:</strong> {animal.productiveStatus || '—'}</Col>
            </Row>
            <Row className="mb-3">
                <Col md={4}><strong>Estado:</strong> {animal.status || '—'}</Col>
                <Col md={4}><strong>¿Para revisar?:</strong> {animal.forReview ? 'Sí' : 'No'}</Col>
            </Row>
        </>
    )
}
